<app-header></app-header>
<main class="siteMainContent">
  <h4 class=" container my-2 text-center p-4 rounded-2 bg-secondary">There are no bridge slots currently available for BSC to ETH LBLOCK. Please check Telegram for more information.</h4>
  <router-outlet></router-outlet>
</main>
<div class="loaderWrapper text-center text-primary" *ngIf="showLoader">
  <img src="./assets/images/loader.svg" alt="" class="mb-3">
  <span class="d-block fs-5 fw-medium text-white">Please wait...</span>
</div>
